<template>
  <div>
    <div class="content_box">
      <el-row>
        <el-col :span="8" class="leftPart">
          <el-card class="box-card" shadow="always">
            <div class="user-info">
              <img src="https://zkycyd.oss-cn-beijing.aliyuncs.com/public/logo.png" alt="" class="user-info-img">
              <div>
                <p class="user-name"><i class="el-icon-user"></i> {{name}}</p>
                <p class="user-name"><i class="el-icon-mobile-phone"></i> {{userName}}</p>

              </div>

            </div>
            <div class="user-info2">
              <div>

                <p class="user-name">
                  <strong>
                    <i class="el-icon-medal-1"></i>
                    <i class="el-icon-medal-1"></i>
                    <i class="el-icon-medal-1"></i>
                    诚信服务，合规经营
                    <i class="el-icon-medal-1"></i>
                    <i class="el-icon-medal-1"></i>
                    <i class="el-icon-medal-1"></i>
                  </strong>
                </p>
                <!--<p class="user-name"><i class="el-icon-watch-1"></i> 上次登陆时间 : {{last_login_time|dateFormat}}</p>-->
                <p class="user-identity"><i class="el-icon-map-location"></i> 上次登录IP : {{last_login_ip}}</p>

              </div>
            </div>

          </el-card>
          <h2 class="noteTitle">到期提醒</h2>
          <el-table :data="tableData" border :header-cell-style="{background:'#e5e5e5',color:'#333333'}">

            <el-table-column  prop="content" label="提醒内容" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.title}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.title}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="逾期" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.yuqishu}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.yuqishu}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="1-3天内" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.yidaosanshu}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.yidaosanshu}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="4-10天内" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.sidaoshishu}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.sidaoshishu}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="11-30天内" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.sanshitianshu}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.sanshitianshu}}</el-button>
              </template>
            </el-table-column>

<!--            <el-table-column v-for="(label,content) in dataLabel" :key="label" :prop="content" :label="label" :show-overflow-tooltip='true'>-->
<!--              -->
<!--            </el-table-column>-->
          </el-table>
          <h2 class="noteTitle">审验提醒</h2>
          <el-table :data="remindList2" border :header-cell-style="{background:'#e5e5e5',color:'#333333'}">

            <el-table-column  prop="content" label="提醒内容" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.title}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.title}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="逾期" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.yuqi}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.yuqi}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="30天内到期" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.sanshitian}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.sanshitian}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="31-60天内" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.sanshiliushi}}</el-button>
<!--                <el-link :href="scope.row.url">{{scope.row.sanshiliushi}}</el-link>-->
              </template>
            </el-table-column>
            <el-table-column  prop="content" label="61-90天内" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
<!--                <el-link :href="scope.row.url">{{scope.row.liushijiushi}}</el-link>-->
                <el-button class="buttonStyle" type="info" @click="goToAbout(scope.row.url)">{{scope.row.liushijiushi}}</el-button>
              </template>
            </el-table-column>

            <!--            <el-table-column v-for="(label,content) in dataLabel" :key="label" :prop="content" :label="label" :show-overflow-tooltip='true'>-->
            <!--              -->
            <!--            </el-table-column>-->
          </el-table>
        </el-col>
        <el-col :span="16" class="rightPart">
          <el-card v-for="item in countData" :key="item.name" @click.native="changeChart(item.requestType)" class="countData" :body-style="{display:'flex',padding:0}" >
            <i :class="`el-icon-${item.icon}`" :style="{backgroundColor:item.color,color:'#fff' }"></i>
            <div >
              <p class="name">{{ item.title }}</p>
              <p class="value">{{ item.total }}</p>
            </div>
          </el-card>
          <el-card class="zhexian" ref="echarts1">
            折线图部分
          </el-card>
          <div class="smallpics">
            <el-card class="box-card" style="width: 50%;" :body-style="{height:'200px',overflow:'hidden'}">
              <div slot="header" class="clearfix">
                <span>优质合作推荐</span>
              </div>
<!--              <video src="https://www.w3school.com.cn/i/movie.ogg" controls="controls"></video>-->
              <img src="https://zkycyd.oss-cn-beijing.aliyuncs.com/shopApplet/banner/010ae9e12cae1cb4574696a96f345c3d(3).png" style="width: 480px;height: 160px; margin-bottom: 10px;">
            </el-card>
            <el-card class="box-card" style="width: 50%;" :body-style="{height:'200px',overflowY:'auto',padding:'0 20px'}">
              <div slot="header" class="clearfix"><span>公告消息</span></div>
              <div class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false">
                <img src="https://zkycyd.oss-cn-beijing.aliyuncs.com/shopApplet/banner/banner.png" style="width: 500px;height: 180px;margin-top: 10px;">
                <p class="tip" >经营范围：在当东省范围内代理销售保险产品；代理收取呆险费；代理相关保险业务的损失勘察和理赔；山东省保监局批准的其他业务。(依法须经批准的项目，经相关部门批准后方可开展经营活动)</p>
                <div v-for="item in count" :key="item.id" class="text item" @click="showNew(item.content)">
                  <span>{{item.title}}</span>
                  <span>{{item.receive_time|dateFormat}}</span>
                </div>
                <p class="tip" v-if="loading">加载中……</p>
                <p class="tip" v-if="noMore">没有更多了</p>

              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span v-html="noticeMsg"></span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import moment from "moment";
export default {
  data() {
    return {
      name:sessionStorage.getItem("name"),
      userName:sessionStorage.getItem("userName"),
      last_login_time:sessionStorage.getItem("last_login_time"),
      last_login_ip:sessionStorage.getItem("last_login_ip"),
      tableData: [],
      remindList2: [],
      dataLabel: {
        title: "提醒内容",
        yuqishu:"逾期",
        yidaosanshu:"1-3天内到期",
        sidaoshishu:"四到十天到期",
        sanshitianshu: "三十天内到期",
      },
      countData: [],
      count:[],
      loading: false,
      page:1,
      last_page:5,
      pageSize:10,
      dialogVisible:false,
      noticeMsg:'',
      echarts1:''
    }
  },
  mounted() {
    //基于准备好的dom，初始化echarts实例
    //const echarts1 = echarts.init(document.getElementsByClassName('zhexian').item(0))
    this.echarts1 = echarts.init(document.getElementsByClassName('zhexian').item(0))
    this.getBrokenLineContent()
  },
  created() {
    this.getNoticeData()
    this.getIndexInfoData()
  },
  computed: {
    noMore () {
      return this.page >= this.last_page
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    load(){
      if(this.loading){
        return false
      }
      this.loading = true
      setTimeout(() => {
        //this.count += 2
        this.page++
        this.pageSize = this.page * this.pageSize
        this.getNoticeData()
        this.loading = false
      }, 2000)
    },
    showNew(msg){
      ////console.log(msg);
      this.dialogVisible = true
      this.noticeMsg = msg
    },
    //切换折线图
    changeChart(typeId){
        this.getBrokenLineContent(typeId)
    },
    //获取公告数据接口
    getNoticeData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page:1,//this.page,
        per_page:this.pageSize
      }
      this.$axios.getNotice(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data.data);
          this.count = res.data.data
          this.last_page = res.data.last_page
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    //set 折线图数据
    getBrokenLineContent(typeId=1) {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        requestType:typeId
      }
      this.$axios.getShopChartInfo(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data);
          //指定图表的配置项和数据
          var echarts1Option = {
            title: {
              text: res.data.title
            },
            tooltip: {},
            legend: {
              data: [res.data.title]
            },
            xAxis: {
              data: res.data.date
            },
            yAxis: {},
            series: [
              {
                name: res.data.title,
                type: 'line',
                data: res.data.num
              }
            ]
          }
          this.echarts1.setOption(echarts1Option)
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    //首页接口（数据）
    getIndexInfoData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getIndexInfo(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data);
          this.tableData = res.data.remindList
          this.remindList2 = res.data.remindList2
          this.countData = res.data.carSumList
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    //跳转页面
    goToAbout(url){
      this.$router.push('/'+url);
    },
  },
  filters: {
    /**
     * @param {
     *
     * }
     */
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
}
</script>
<style scoped lang="less">
.leftPart {
  padding-right: 10px;
}
//img {
//  height: 150px;
//  margin-right: 40px;
//  border-radius: 50%;
//}
.user-info {
  display: flex;
  align-items: center;
  //padding-bottom: 20px;
  //margin-bottom: 20px;
  border-bottom: 1px solid #ccc;

  .user-name {
    font-size: 16px;
    margin: 0px;
    margin-bottom: 10px;
  }

  .user-identity {
    margin: 0px;
  }
}
.leftPart span {
  margin-left: 60px;
}
p {
  margin: 0;
}
.countData {
  width: 30%;
  margin-right: 9px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  i {
    height: 80px;
    width: 80px;
    font-size: 20px;
    line-height: 80px;
    text-align: center;
  }

  .value {
    font-size: 20px;
    margin-bottom: 10px;

  }

  .name {
    text-align: center;
    color: #999;
    font-size: 14px;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-left: 15px;
  }
}
.rightPart {
  display: flex;
  flex-wrap: wrap;
}
.el-col {
  padding: 10px;
}
.zhexian {
  width: 100%;
  height: 250px;
}
.smallpics {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
  .pic {
    height: 195px;
    width: 48%;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.list {
  .item {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    cursor:pointer;
    span:nth-child(1) {
      flex: 1;
      width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .item:hover {
    color: #409EFF;
  }
  .tip {
    text-align: center;
  }
}
.user-info-img {
  width: 60px;
  height: 60px;
  //border-radius: 50%;
  //border: 1px #000000 solid;
  margin-left: 10px;
  margin-right: 30px;
}
.user-info2 {
  display: flex;
  align-items: center;
  margin-top: 10px;
  .user-name {
    font-size: 16px;
    margin: 0px;
    margin-bottom: 10px;
  }

  .user-identity {
    margin: 0px;
  }
}
.noteTitle{
  text-align: center;
  width: 100%;
  margin: 10px;
  font-size: 24px;
}
.buttonStyle{
  width: 100%;
  height: 100%;
  background: #ffffff;
  color: #606266;
  border-color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/view/Welcome.vue